/**
 * MailboxAvatar — small avatar for a mailbox object.
 * Props: mailbox ({ name, kind, avatar_url, dicebear_avatar_url }), size (number, default 28)
 */

import { h } from 'preact'

export function MailboxAvatar({ mailbox, size = 28 }) {
  const initials = (mailbox.name || '?').slice(0, 2).toUpperCase()
  const isPersonal = mailbox.kind === 'personal'
  const style = { width: size, height: size, borderRadius: '50%', overflow: 'hidden', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }
  const title = isPersonal ? `${mailbox.name || ''} (personal)` : (mailbox.name || undefined)
  const className = isPersonal ? 'mailbox-avatar mailbox-avatar--personal' : 'mailbox-avatar'

  if (mailbox.avatar_url) {
    return <img class={className} src={mailbox.avatar_url} alt={mailbox.name} title={title} style={{ ...style, objectFit: 'cover' }} />
  }
  if (mailbox.dicebear_avatar_url) {
    return <img class={className} src={mailbox.dicebear_avatar_url} alt={mailbox.name} title={title} style={{ ...style, objectFit: 'cover' }} />
  }
  return (
    <span class={`${className} avatar-initials`} title={title} style={{ ...style, fontSize: Math.max(8, Math.round(size * 0.4)) }}>
      {initials}
    </span>
  )
}
